import { SecurableActivityType } from './securable-activity-type';

export class SecurableActivity {
  constructor(
    public id: string,
    public name: string,
    public activityType: SecurableActivityType,
    public securables: SecurableActivity[],
    public hasDynamicallyGeneratedSecurables: boolean
  ) {}
}
